import { call, put, select, takeLatest } from "redux-saga/effects";

import { PatientsAPI } from "../../../api/patientsAPI";
import {
  SET_TOAST,
  DOWNLOAD_REPORT_REQUEST,
  // DOWNLOAD_REPORT_SUCCESS,
  DOWNLOAD_REPORT_ERROR,
  DOWNLOAD_REPORT_SUCCESS
} from "../../actions";
import {ToastType} from "../../../utils/interfaces";
import {getCurrentReport} from "../../selectors/patientsSelector";

function* workerDownloadReport(): Generator<any> {
  try {
    const currentReport: any = yield select(getCurrentReport);

    if (currentReport?.id) {
      const data: any = yield call(PatientsAPI.download, currentReport.id);
      const fileBlob = new Blob([data]);
      const downloadUrl = window.URL.createObjectURL(fileBlob);

      const link = document.createElement('a');
      link.href = downloadUrl;

      link.setAttribute('download', currentReport?.fileName);

      document.body.appendChild(link);
      link.click();


      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    }

    yield put({
      type: DOWNLOAD_REPORT_SUCCESS,
      payload: { currentReport: null }
    });
  } catch (error: any) {
    yield put({
      type: DOWNLOAD_REPORT_ERROR,
      payload: { code: error?.response?.status, message: error?.message }
    });
    yield put({
      type: SET_TOAST,
      payload: {
        open: true,
        message: "Something went wrong",
        type: ToastType.ERROR,
      }
    });
  }
}

export function* watcherDownloadReport() {
  yield takeLatest(DOWNLOAD_REPORT_REQUEST, workerDownloadReport);
}
